import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { isOnline } from '../helpers'

type NetworkState = {
  isOnline: boolean
}

const initialState: NetworkState = {
  isOnline: isOnline(),
}

export const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setOnline: (state, { payload }: PayloadAction<boolean>) => {
      state.isOnline = payload
    },
  },
  selectors: {
    selectOnline: (state) => state.isOnline,
  },
})
